import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "AdsExperiment" */ './lazyIndex')
);

export let updateAdExp2UserOptionLazy = new LazyAction(lazyModule, m => m.updateAdExp2UserOption);
